import { Button, Icons, Intent, Size } from "construct-ui";
import 'CssFolder/campaign/campaign-list-item.scss';
import ViewBase from "../../view-base.view";
import moment from "moment";
import { formats as FORMATS } from "../../../config/constants";

export default function CampaignListItemView() {
  ViewBase.call(this);

  let campaign;

  let _onCheckboxChange = (CampaignId, isChecked) => { };
  // let _viewUpdateCampaignQuestions = (id) => { };
  let _viewUpdateCampaignInfo = () => { };
  let _viewCampaignDetails = () => { };
  let _downloadPPT = () => { };
  let _downloadExcelForCompliantElements = () => { };
  let _downloadFixtureSkuMapping = () => { console.log('test download fixture sku'); };

  return {
    oninit: (vnode) => {
      campaign = vnode.attrs.campaign;
      if (vnode.attrs.onCheckboxChange) {
        _onCheckboxChange = vnode.attrs.onCheckboxChange;
      }
      // if (vnode.attrs.viewUpdateCampaignQuestions) {
      //   _viewUpdateCampaignQuestions = vnode.attrs.viewUpdateCampaignQuestions;
      // }
      if (vnode.attrs.viewUpdateCampaignInfo) {
        _viewUpdateCampaignInfo = vnode.attrs.viewUpdateCampaignInfo;
      }
      if (vnode.attrs.viewCampaignDetails) {
        _viewCampaignDetails = vnode.attrs.viewCampaignDetails;
      }
      if (vnode.attrs.downloadCampaignUploadedImagePPT) {
        _downloadPPT = vnode.attrs.downloadCampaignUploadedImagePPT;
      }
      if (vnode.attrs.downloadExcelForCompliantElements) {
        _downloadExcelForCompliantElements = vnode.attrs.downloadExcelForCompliantElements;
      }
      if (vnode.attrs.downloadFixtureSkuMapping) {
        _downloadFixtureSkuMapping = vnode.attrs.downloadFixtureSkuMapping;
      }
    },
    view: (vnode) => {
      return [
        m('.campaign-item.card',
          m('.card-body',
            m('input.form-check-input.flex-shrink-0[type=checkbox]', {
              checked: vnode.attrs.isSelected,
              onchange: (e) => {
                _onCheckboxChange(campaign.campaignID, Boolean(e.target.checked))
              }
            }),
            m('.campaign-item-content',
              m('.campaign-item-content__top',
                // Campaign Info
                m('.campaign-info',
                  m('.campaign-title', m('a[href="javascript:void(0);"]', {
                    title: this.getText("LT00000520", "View / Update Campaign Information"),
                    onclick: _viewUpdateCampaignInfo
                  },
                    m('span.fw-bold', campaign.campaignName)
                  )),
                  m('.campaign-category', `${this.getText('LT00001198', 'Image Type')}: ${campaign.planogramTypeName}`),
                  m('.campaign-user', `Period: ${moment(campaign.periodStart).format(FORMATS.dateFormat)} ~ ${moment(campaign.periodEnd).format(FORMATS.dateFormat)}`)
                ),
                // Campaign compliance Info
                m('.campaign-question',
                  m('.campaign-question-count',
                    m('label.me-1', this.getText("LT00001203", "No. of Target"), ':'),
                    campaign.target ?? '-'
                  ),
                  m('.campaign-target-response',
                    m('label.me-1', this.getText("LT00001231", "Response / Target"), ':'),
                    m('span',
                      `${campaign.response ?? '-'} / ${campaign.target ?? '-'} (${campaign.targetResponseRate.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%)`
                    ),
                  ),
                  m('.campaign-target-response',
                    m('label.me-1', this.getText("LT00001233", "Compliant / Elements"), ':'),
                    m('a[href="javascript:void(0);"]', {
                      title: this.getText("LT00001234", "Download Compliant / Elements Summary"),
                      onclick: _downloadExcelForCompliantElements
                    },
                      `${campaign.compliant ?? '-'} / ${campaign.element ?? '-'} (${campaign.elementCompliantRate.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%)`
                    ),
                  )
                ),
                // Action buttons
                m('.campaign-actions_1',
                  m(Button, {
                    iconLeft: Icons.EYE,
                    intent: Intent.PRIMARY,
                    label: this.getText("LT00001312", "View Uploaded Images"),
                    outlined: true,
                    rounded: true,
                    size: Size.XS,
                    onclick: _viewCampaignDetails
                  }),

                ),
              ),
              m('hr'),
              m('.campaign-item-content__bottom',

                m('.flex-grow-1.d-flex.flex-wrap.gap-4.align-items-center',
                  m('label', { style: 'white-space: nowrap;' },
                    m('.inline-label-with-point'),
                    `${this.getText("LT00000273", "Created By")} : ${campaign.createUserID ?? '-'} | ${campaign.createDate ? moment(campaign.createDate).format(FORMATS.dateFormat) : '-'}`
                  ),
                  m('label', { style: 'white-space: nowrap;' },
                    m('.inline-label-with-point'),
                    `${this.getText("LT00000274", "Updated By")} : ${campaign.updateUserID ?? '-'} | ${campaign.updateDate ? moment(campaign.updateDate).format(FORMATS.dateFormat) : '-'}`
                  ),
                  m('span', campaign.status === '1' ? m('span.badge.rounded-pill.active', { style: { width: 'auto' } }, this.getText("LT00000025", "Active")) : m('span.badge.rounded-pill.inactive', { style: { width: 'auto' } }, this.getText("LT00000896", "Inactive"))),

                ),

                m('.campaign-actions',
                  m(Button, {
                    iconLeft: Icons.DOWNLOAD,
                    intent: Intent.PRIMARY,
                    label: this.getText('LT00001227', 'Download Mapping'),
                    outlined: true,
                    rounded: true,
                    size: Size.XS,
                    disabled: vnode.attrs.isDownloadingMappingOrPPT.mapping,
                    loading: vnode.attrs.isDownloadingMappingOrPPT.mapping,
                    onclick: _downloadFixtureSkuMapping
                  }),
                  m(Button, {
                    iconLeft: Icons.DOWNLOAD,
                    intent: Intent.PRIMARY,
                    label: this.getText("LT00001226", "Download PPT"),
                    outlined: true,
                    rounded: true,
                    size: Size.XS,
                    disabled: vnode.attrs.isDownloadingMappingOrPPT.ppt,
                    loading: vnode.attrs.isDownloadingMappingOrPPT.ppt,
                    onclick: _downloadPPT,
                  })
                )
              ),
            ),
          )
        ),
        // m(Dialog, {
        //   closeOnOutsideClick: false,
        //   isOpen: showQuickCampaignDownloadModal,
        //   onClose: (e) => { showQuickCampaignDownloadModal = false; },
        //   title: this.getText("LT00000525", "Export Quick Campaign") + ' - ' + Campaign.title,
        //   content: m(ExportQuickCampaignView, {
        //     data: Campaign,
        //     closeModal: e => showQuickCampaignDownloadModal = false
        //   }),
        // })
      ]
    }
  }
}
